import React from "react";
import SEO from "../common/SEO";
import HeaderOne from "../common/header/HeaderOne";
import FooterTwo from "../common/footer/FooterTwo";
import { useTranslation } from "react-i18next";
import { FiArrowRight } from "react-icons/fi";
import DemoLine from "../elements/split/chart";
import MapComponent from "../elements/split/map";
import "./BusinessConsulting2.css";

const BusinessConsulting2 = () => {
  const { t } = useTranslation();

  const frameworkItems = [
    {
      letter: "D",
      name: t("dddi.framework.data.name"),
      desc: t("dddi.framework.data.desc"),
    },
    {
      letter: "D",
      name: t("dddi.framework.development.name"),
      desc: t("dddi.framework.development.desc"),
    },
    {
      letter: "D",
      name: t("dddi.framework.design.name"),
      desc: t("dddi.framework.design.desc"),
    },
    {
      letter: "I",
      name: t("dddi.framework.insight.name"),
      desc: t("dddi.framework.insight.desc"),
    },
  ];

  const workSteps = [
    { number: "01", title: t("dddi.how_we_work.step1") },
    { number: "02", title: t("dddi.how_we_work.step2") },
    { number: "03", title: t("dddi.how_we_work.step3") },
    { number: "04", title: t("dddi.how_we_work.step4") },
  ];

  const groupEntities = [
    { name: "Cyberate Technologies", desc: t("dddi.who_we_are.group_tech"), accent: false },
    { name: "Cyberate Project Management", desc: t("dddi.who_we_are.group_pm"), accent: false },
    { name: "Cyberate Investments", desc: t("dddi.who_we_are.group_inv"), accent: true },
  ];

  return (
    <>
      <SEO title="Cyberate Investments - Investment & Commercial Decision Intelligence | A DDDI Group Company" />
      <main className="page-wrapper">
        <HeaderOne btnStyle="round" HeaderSTyle="header-not-transparent" />

        {/* Hero Banner */}
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "100vh",
            overflow: "hidden",
            background: "#0c0b09",
          }}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              position: "absolute",
              top: 0,
              left: 0,
              zIndex: 1,
            }}
          >
            <source
              src={`${process.env.PUBLIC_URL || ""}/images/about/Cyberate_Investment_final.mp4`}
              type="video/mp4"
            />
          </video>
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background:
                "linear-gradient(180deg, rgba(12,11,9,0.55) 0%, rgba(12,11,9,0.35) 45%, rgba(12,11,9,0.82) 100%)",
              zIndex: 2,
            }}
          ></div>
          <div
            className="container"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
              zIndex: 3,
              width: "100%",
            }}
          >
            <div className="dddi-hero-content">
              <span className="dddi-eyebrow">{t("dddi.hero.tagline")}</span>
              <h1 className="dddi-hero-title">
                {t("dddi.hero.title_1")} {t("dddi.hero.title_2")}
              </h1>
              <p className="dddi-hero-sub">{t("dddi.hero.subtitle")}</p>
              <div className="dddi-hero-cta">
                <button
                  className="dddi-btn"
                  onClick={() => {
                    window.location.href = "/Service";
                  }}
                >
                  {t("dddi.hero.cta")} <FiArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Who We Are */}
        <section className="dddi-section">
          <div className="container">
            <div className="dddi-section-head">
              <span className="dddi-eyebrow">DDDI Group</span>
              <h2 className="dddi-title">{t("dddi.who_we_are.title")}</h2>
              <p className="dddi-lede">{t("dddi.who_we_are.p1")}</p>
            </div>
            <div className="dddi-grid dddi-grid--3">
              {groupEntities.map((entity) => (
                <div
                  key={entity.name}
                  className={`dddi-card${entity.accent ? " dddi-card--accent" : ""}`}
                >
                  <h4 className="dddi-card-title">{entity.name}</h4>
                  <p className="dddi-card-text">{entity.desc}</p>
                </div>
              ))}
            </div>
            <p className="dddi-lede" style={{ textAlign: "center", marginTop: 48 }}>
              {t("dddi.who_we_are.p2")}
            </p>
          </div>
        </section>

        {/* The DDDI Framework */}
        <section className="dddi-section dddi-section--alt">
          <div className="container">
            <div className="dddi-section-head">
              <span className="dddi-eyebrow">Data · Development · Design · Insight</span>
              <h2 className="dddi-title">{t("dddi.framework.title")}</h2>
              <p className="dddi-lede">{t("dddi.framework.intro")}</p>
            </div>
            <div className="dddi-grid dddi-grid--4">
              {frameworkItems.map((item, index) => (
                <div key={index} className="dddi-card">
                  <div className="dddi-card-letter">{item.letter}</div>
                  <h4 className="dddi-card-title">{item.name}</h4>
                  <p className="dddi-card-text">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* How We Work */}
        <section className="dddi-section">
          <div className="container">
            <div className="dddi-section-head">
              <span className="dddi-eyebrow">Process</span>
              <h2 className="dddi-title">{t("dddi.how_we_work.title")}</h2>
              <p className="dddi-lede">{t("dddi.how_we_work.intro")}</p>
            </div>
            <div className="dddi-grid dddi-grid--4">
              {workSteps.map((step) => (
                <div key={step.number} className="dddi-step">
                  <div className="dddi-step-number">{step.number}</div>
                  <p className="dddi-step-title">{step.title}</p>
                </div>
              ))}
            </div>
            <p className="dddi-note">{t("dddi.how_we_work.note")}</p>
          </div>
        </section>

        {/* Experience & Scale */}
        <section className="dddi-section dddi-section--alt">
          <div className="container">
            <div className="dddi-section-head">
              <span className="dddi-eyebrow">Since 2020</span>
              <h2 className="dddi-title">{t("dddi.scale.title")}</h2>
              <p className="dddi-lede">{t("dddi.scale.p1")}</p>
            </div>
            <div className="dddi-stat">
              <div className="dddi-stat-value">AUD 31M</div>
              <p className="dddi-stat-label">{t("dddi.scale.item1")}</p>
            </div>
            <div className="dddi-facts">
              <div className="dddi-fact">{t("dddi.scale.item2")}</div>
              <div className="dddi-fact">{t("dddi.scale.item3")}</div>
            </div>
            <div className="dddi-grid dddi-grid--2" style={{ marginTop: 56 }}>
              <div className="dddi-panel">
                <h3 className="dddi-panel-title">{t("607")}</h3>
                <div className="map-wrapper">
                  <MapComponent />
                </div>
              </div>
              <div className="dddi-panel">
                <h3 className="dddi-panel-title">{t("606")}</h3>
                <div className="chart-wrapper">
                  <DemoLine />
                </div>
              </div>
            </div>
            <p className="dddi-fineprint">{t("dddi.scale.disclaimer")}</p>
          </div>
        </section>

        {/* CTA */}
        <section className="dddi-section">
          <div className="container">
            <div className="dddi-section-head" style={{ marginBottom: 0 }}>
              <h2 className="dddi-title">{t("dddi.cta.title")}</h2>
              <p className="dddi-lede">{t("dddi.cta.sub")}</p>
              <div style={{ marginTop: 36 }}>
                <button
                  className="dddi-btn"
                  onClick={() => {
                    window.location.href = "/FreeConsult";
                  }}
                >
                  {t("dddi.nav.consult")} <FiArrowRight />
                </button>
              </div>
            </div>
          </div>
        </section>

        {/* Compliance Statement */}
        <section className="dddi-section" style={{ paddingTop: 0 }}>
          <div className="container">
            <div className="dddi-compliance">
              <span className="dddi-eyebrow">{t("dddi.compliance.title")}</span>
              <p>{t("dddi.compliance.short")}</p>
            </div>
          </div>
        </section>

        <FooterTwo />
      </main>
    </>
  );
};

export default BusinessConsulting2;
